import { PositionNumber, PositionNumberType } from 'api/common/constants'
import { Status } from 'api/common/statuses'
import { NoticeSimplified, PaymentAlert, Position } from 'api/common/types'
import myPageAPI from 'api/myPage'
import { paymentAlertAPI } from 'api/paymentAlert'
import { portalRedirectUrlAPI } from 'api/portal'
import { positionsAPI } from 'api/position'
import Footer from 'components/Footer'
import Header from 'components/Header'
import { NoticeListCard } from 'components/NoticeListCard'
import { PaymentAlertCard } from 'components/PaymentAlertCard'
import { QrCode } from 'components/QrCode'
import AUBEQuestDeal from 'images/deal_aube_quest.png'
import AUBESite from 'images/aube_site.jpg'
import * as React from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import loginData from 'utilities/loginData'
import { PaymentAlertResponse } from 'api/common/responses'
import axios from 'axios'

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const [mainPositionId, setMainPositionId] = React.useState(0)
  const [connectorEmail, setConnectorEmail] = React.useState('')
  const [connectorName, setConnectorName] = React.useState('')
  const [notices, setNotices] = React.useState<NoticeSimplified[]>([])
  const [paymentAlerts, setPaymentAlerts] = React.useState<PaymentAlert[]>([])
  const [showModal, setShowModal] = React.useState(false)
  const [showPortalModal, setShowPortalModal] = React.useState(false)
  const [isPortalLoading, setIsPortalLoading] = React.useState(false)
  const [portalErrorMessage, setPortalErrorMessage] = React.useState<string | null>(null)
  const [portalToken, setPortalToken] = React.useState<string | null>(null)
  const [portalTokenExpiresAt, setPortalTokenExpiresAt] = React.useState<string | null>(null)
  const [portalTokenUid, setPortalTokenUid] = React.useState<string | null>(null)
  const [portalPositions, setPortalPositions] = React.useState<Position[]>([])
  const [selectedPortalPosition, setSelectedPortalPosition] = React.useState<PositionNumberType | null>(null)
  const [selectedPortalUid, setSelectedPortalUid] = React.useState<string | null>(null)
  React.useEffect(() => {
    if (!loginData.isLoggedIn()) {
      navigate('/')
    } else {
      paymentAlertAPI((status: Status, result: PaymentAlertResponse) => {
        if (status === Status.Success) {
          setPaymentAlerts(result.paymentAlerts)
        }
      })
      myPageAPI((status, result) => {
        if (status === Status.Success) {
          setMainPositionId(result.mainPositionId)
          setConnectorName(result.connectorName)
          setConnectorEmail(result.connectorEmail)
          setNotices(result.notices)
        }
      })
      console.log('paymentAlertAPI call')
      paymentAlertAPI((status: Status, result: PaymentAlertResponse) => {
        console.log('paymentAlertAPI callback', status, result)
        if (status === Status.Success) {
          setPaymentAlerts(result.paymentAlerts)
        }
      })
      positionsAPI((result) => {
        const sortedPositions = [...result.positions]
          .sort((a, b) => a.positionNumber - b.positionNumber)
          .filter((position) => {
            // 名義変更済み・名義変更依頼中のポジションを除外
            return !position.isChangedAssignment
          })
        setPortalPositions(sortedPositions)
        if (sortedPositions.length === 0) {
          setSelectedPortalPosition(null)
          setSelectedPortalUid(null)
          setPortalToken(null)
          setPortalTokenExpiresAt(null)
          setPortalTokenUid(null)
          return
        }

        const initialPosition = sortedPositions.find((position) => position.atemQuestId) ?? sortedPositions[0]
        setSelectedPortalPosition(initialPosition.positionNumber)
        setSelectedPortalUid(initialPosition.atemQuestId || null)
        setPortalToken(null)
        setPortalTokenExpiresAt(null)
        setPortalTokenUid(null)
      })
    }
  }, [navigate])

  const handlePortalModalOpen = React.useCallback(() => {
    setPortalErrorMessage(null)
    setShowPortalModal(true)
  }, [])

  const handlePortalModalClose = React.useCallback(() => {
    if (isPortalLoading) {
      return
    }
    setShowPortalModal(false)
    setPortalErrorMessage(null)
  }, [isPortalLoading])

  const handlePortalPositionChange = React.useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      const rawValue = event.target.value
      if (!rawValue) {
        setSelectedPortalPosition(null)
        setSelectedPortalUid(null)
        setPortalToken(null)
        setPortalTokenExpiresAt(null)
        setPortalTokenUid(null)
        return
      }

      const value = Number(rawValue) as PositionNumberType
      const position = portalPositions.find((item) => item.positionNumber === value)
      const atemQuestId = position?.atemQuestId ?? ''

      setSelectedPortalPosition(value)
      setSelectedPortalUid(atemQuestId || null)

      if (!atemQuestId || portalTokenUid !== atemQuestId) {
        setPortalToken(null)
        setPortalTokenExpiresAt(null)
        setPortalTokenUid(null)
      }
    },
    [portalPositions, portalTokenUid],
  )

  const handlePortalLinkButton = React.useCallback(async () => {
    if (isPortalLoading) {
      return
    }
    if (!selectedPortalPosition) {
      setPortalErrorMessage('AUBEサイトにアクセスするポジションを選択してください。')
      return
    }
    if (!selectedPortalUid) {
      setPortalErrorMessage('選択したポジションに紐づくIDが見つかりません。別のIDを選択してください。')
      return
    }
    setPortalErrorMessage(null)
    setIsPortalLoading(true)

    const now = Date.now()
    let tokenForRequest: string | undefined
    if (portalToken && portalTokenUid === selectedPortalUid) {
      if (!portalTokenExpiresAt) {
        tokenForRequest = portalToken
      } else {
        const expiresAt = new Date(portalTokenExpiresAt).getTime()
        if (Number.isNaN(expiresAt)) {
          tokenForRequest = portalToken
        } else if (expiresAt > now) {
          tokenForRequest = portalToken
        } else {
          setPortalToken(null)
          setPortalTokenExpiresAt(null)
          setPortalTokenUid(null)
        }
      }
    } else if (portalTokenUid && portalTokenUid !== selectedPortalUid) {
      setPortalToken(null)
      setPortalTokenExpiresAt(null)
      setPortalTokenUid(null)
    }

    try {
      const { status, data } = await portalRedirectUrlAPI(tokenForRequest, selectedPortalUid)
      if (status !== Status.Success) {
        if (status === Status.InternalError) {
          setPortalErrorMessage('ポータルへの接続に失敗しました。時間を置いて再度お試しください。')
        } else {
          setPortalErrorMessage('ポータルURLの取得に失敗しました。')
        }
        return
      }

      const redirectInfo = data?.response ?? data
      const redirectUrl = redirectInfo?.redirectUrl
      if (!redirectUrl) {
        setPortalErrorMessage('ポータルURLの取得に失敗しました。')
        return
      }

      if (redirectInfo?.portalToken) {
        setPortalToken(redirectInfo.portalToken)
        setPortalTokenUid(selectedPortalUid)
      } else if (tokenForRequest) {
        setPortalTokenUid(selectedPortalUid)
      } else {
        setPortalTokenUid(null)
      }
      if (redirectInfo?.expiresAt) {
        setPortalTokenExpiresAt(redirectInfo.expiresAt)
      }

      setShowPortalModal(false)
      window.location.assign(redirectUrl)
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 429) {
          setPortalErrorMessage('アクセスが集中しています。時間を置いて再度お試しください。')
        } else if (error.response?.status === 401) {
          setPortalErrorMessage('ログインセッションが切れています。再度ログインしてください。')
        } else {
          const message =
            typeof error.response?.data?.message === 'string'
              ? error.response?.data?.message
              : 'ポータルURLの取得に失敗しました。'
          setPortalErrorMessage(message)
        }
      } else {
        setPortalErrorMessage('ポータルURLの取得に失敗しました。')
      }
    } finally {
      setIsPortalLoading(false)
    }
  }, [
    isPortalLoading,
    portalToken,
    portalTokenExpiresAt,
    portalTokenUid,
    selectedPortalUid,
    selectedPortalPosition,
  ])

  /**
   * 「ログアウト」ボタン
   */
  const handleLogoutButton = () => {
    loginData.clear()
    navigate('/')
  }
  return (
    <>
      <Header title="マイページ" />
      <main>
        <section className="bg-white px-4 pb-3">
          {paymentAlerts.map((paymentAlert: PaymentAlert, index: number) => (
            <PaymentAlertCard paymentAlert={paymentAlert} key={index} />
          ))}
        </section>
        <section className="mx-4 my-5">
          <h3 className="fw-bold">お知らせ</h3>
          {notices.map((notice, index) => (
            <NoticeListCard notice={notice} key={index} />
          ))}
          <div className="mt-3">
            <Button variant="primary" className="w-100 py-4" href="/notificationList">
              お知らせ一覧を表示
            </Button>
          </div>
        </section>
        <section className="bg-white px-4 py-5">
          <div>
            <div className="fw-bold">コネクター名</div>
            <hr className="my-2" />
            <div>{connectorName}</div>
          </div>
          <div className="mt-5">
            <div className="fw-bold">メールアドレス</div>
            <hr className="my-2" />
            <div>{connectorEmail}</div>
          </div>
          <div className="mt-5">
            <div className="fw-bold">コネクターID（メインポジション）</div>
            <hr className="my-2" />
            <div>{mainPositionId}</div>
          </div>
          <div className="mt-4">
            <Button variant="outline-primary" className="w-100 py-4" onClick={() => setShowModal(true)}>
              QRコードを表示
            </Button>
            <Modal size="sm" show={showModal} onHide={() => setShowModal(false)} aria-labelledby="contained-modal-title-vcenter" centered>
              <Modal.Body className="text-center">
                <QrCode targetString={`${mainPositionId}CCM`} />
              </Modal.Body>
            </Modal>
          </div>
          <div className="mt-4">
            <Button variant="primary" className="w-100 py-4" href="/connectorEdit">
              コネクター情報を変更する
            </Button>
          </div>
          <div className="mt-4">
            <Button variant="primary" className="w-100 py-4" href="/passwordEdit">
              パスワードを変更する
            </Button>
          </div>
          <div className="mt-5">
            <div className="fw-bold">AUBEクエストディール</div>
            <hr className="my-2" />
            <div className="reflection">
              <img src={AUBEQuestDeal} alt="AUBEクエストディール" className="w-100" />
            </div>
            <div className="mt-4">
              <div className="fw-bold">AUBEサイト</div>
              <hr className="my-2" />
              <Button
                variant="outline-primary"
                type="button"
                className="w-100 p-0 border-0 aube-site-button"
                onClick={handlePortalModalOpen}
                disabled={isPortalLoading}
              >
                <img src={AUBESite} alt="AUBEサイト" className="w-100 aube-site-image" />
              </Button>
              {!showPortalModal && portalErrorMessage && <div className="text-danger small mt-2">{portalErrorMessage}</div>}
              <Modal show={showPortalModal} onHide={handlePortalModalClose} centered>
                <Modal.Body>
                  <p className="mb-3">AUBEサイトにアクセスするためのIDを選択してください。選択したIDで、AUBEサイトへ移動します。</p>
                  <Form.Select
                    value={selectedPortalPosition ? String(selectedPortalPosition) : ''}
                    onChange={handlePortalPositionChange}
                    disabled={portalPositions.length === 0 || isPortalLoading}
                    aria-label="AUBEサイト遷移用ポジション選択"
                  >
                    {portalPositions.length === 0 ? (
                      <option value="">選択できるIDがありません</option>
                    ) : (
                      portalPositions.map((position) => {
                        const positionNumber = Number(position.positionNumber)
                        const label =
                          position.positionNumber === PositionNumber.MainPosition
                            ? `メインポジション:${position.atemQuestId || '-'}`
                            : `サブポジション${positionNumber - PositionNumber.MainPosition}:${position.atemQuestId || '-'}`
                        return (
                          <option key={position.positionNumber} value={position.positionNumber}>
                            {label}
                          </option>
                        )
                      })
                    )}
                  </Form.Select>
                  {portalErrorMessage && <div className="text-danger small mt-2">{portalErrorMessage}</div>}
                </Modal.Body>
                <Modal.Footer className="border-0 pt-0">
                  <Button variant="secondary" onClick={handlePortalModalClose} disabled={isPortalLoading}>
                    キャンセル
                  </Button>
                  <Button
                    variant="primary"
                    onClick={handlePortalLinkButton}
                    disabled={isPortalLoading || !selectedPortalPosition || !selectedPortalUid}
                  >
                    {isPortalLoading ? '移動中...' : 'AUBEサイトへ移動'}
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>
          </div>
        </section>
        <section className="bg-white px-4 py-5">
          <div>
            <Button variant="danger" className="w-100 py-4" onClick={handleLogoutButton}>
              ログアウト
            </Button>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
      <style>{`
        .reflection {
          display:inline-block;
          position:relative;
          overflow:hidden;
        }

        .aube-site-button {
          overflow:hidden;
        }

        .aube-site-image {
          max-height:180px;
          object-fit:cover;
        }

        .reflection:after {
          content:"";
          height:100%;
          width:30px;
          position:absolute;
          top:-180px;
          left:0;
          background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.5) 32%, rgba(255, 255, 255, 1) 85%, rgba(255, 255, 255, 0) 100%);
          opacity:0;
          -webkit-transform: rotate(-30deg);
          -webkit-animation: reflection 8s ease-in-out infinite;
        }

        @keyframes reflection {
          0% { -webkit-transform: scale(0) rotate(45deg);opacity: 0; }
          60% { -webkit-transform: scale(0) rotate(45deg);opacity: 0; }
          70% { -webkit-transform: scale(5) rotate(45deg);opacity: 1; }
          100% { -webkit-transform: scale(200) rotate(45deg);opacity: 0; }
        }
        `}</style>
    </>
  )
}

export default SceneComponent
